<template>
  <div class="integrate-app">
    <loading v-if="loading"></loading>
    <div class="header">
        <div class="layout-wrapper">
            <header id="page-topbar">
                <BaseButton variant="secondary" @click="$router.go(-1)">Quay lại</BaseButton>
            <div class="title">
                <p>Liên kết tài khoản {{params.appInfo.shortName}}</p>
            </div>
            </header>
        </div>
    </div>
    <div class="boxContent boxContentExt" style="margin-top: 110px;">
        <div class="__card first-box">
            <h1 class="__card_title">Nhập mã OTP</h1>
            <div>
                <div>Nhập mã chứng thực OTP vừa được gửi đến số điện thoại của bạn (mã OTP sẽ hết hạn trong 15 phút)</div>
                <div v-if="!timeOut">Gửi lại mã trong <b style="color:#007AFF">{{timerCountFormat}}</b></div>
                <span style="text-decoration-line: underline;cursor: pointer;color: #3E69F6;" v-else @click="reSendOTP">Gửi lại mã OTP</span>
            </div>
            <div style="width:100%">
                <el-row>
                    <el-col :span="16">
                        <el-form label-width="120px">
                            <el-form-item label="Mã OTP">
                                <el-input v-model="otpCode"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <div style="width: 100%;text-align: center;">
                    <el-button style="margin-top:24px" @click="activeAccount" type="primary">Gửi mã OTP và thông tin</el-button>
                </div>
            </div>
        </div>
    </div>
  </div>
  
</template>

<script>
import { OtherService } from "@/services/other.service"
import { getStorageItem } from '@/utils/auth'
import Swal from "sweetalert2";

export default {
    data() {
        return {
            loading: false,
            params: getStorageItem('appInfo'),
            otpCode: '',
            activeSuccessModal: false,
            activeFailModal: false,
            timerCount: 30,
            timeOut: false,
        }
    },

    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    this.timeOut = false
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.timeOut = true
                }
                
            },
            immediate: true
        }
    },

    methods: {
        async activeAccount() {
            this.loading = true;
            const param = {
                code: this.otpCode,
                name: this.params.name,
                phone: this.params.phoneNo,
                tokenOTP: this.params.tokenOTP,
            }
            try {
                const res = await OtherService.activeAccountHeyU(param);
                if(res.success) {
                    Swal.fire({
                        icon: 'success',
                        title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                        html:'<p style="margin-bottom: 0">Bạn đã liên kết ứng dụng HeyU thành công.</p><p>Từ giờ bạn có thể sử dụng dịch vụ giao hàng của HeyU.</p>',
                        confirmButtonText: "Xem thông tin ứng dụng",
                    }).then(()=>{
                        localStorage.removeItem('appInfo');
                        this.$router.push('/partners')
                    })
                } else {
                    Swal.fire({
                        title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thất bại</<a>',
                        html:'<p style="margin-bottom: 0">Có vẻ như mã OTP của bạn không đúng, hoặc mã đã hết hạn.</p><p>Vui lòng thử nhập lại mã.</p>',
                        icon: "warning",
                        confirmButtonText: "Thử lại",
                    }).then(()=>{
                        this.$router.push('/partners')
                    });
                }
            } finally {
                this.loading = false
            }
        },

        async reSendOTP() {
            this.loading = true
            try {
                const res = await OtherService.sendSmsOtpHeyU(this.params.phoneNo);
                if (res.success) {
                    let param = {
                      ...this.params,
                      phoneNo: this.params.phoneNo,
                      tokenOTP: res.data.data.otpToken,
                      name: this.params.name
                    }
                    localStorage.setItem("appInfo", JSON.stringify(param))
                    this.timerCount = 30;
                    this.loading = false
                }
            } finally {

            }
        }
    },

    computed: {
        timerCountFormat() {
            let minutes = Math.floor(this.timerCount / 60);
            let seconds = this.timerCount - minutes * 60;
            return `${minutes > 10 ? minutes : `0${minutes}`}:${seconds}`
        }
    }
}
</script>


<style lang="scss" scoped>

.boxContent .__card {
  max-width: 960px;
  padding: 32px;
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">

.swal2-html-container p {
    font-size: 14px;
    margin-bottom: 0;
}
.boxContent {
  margin: 12px 0;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 70%;
}
</style>>
